'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./TrackPartHeader.scss');

var TrackPartHeader = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TrackPartHeader, _Component);

  function TrackPartHeader() {
    (0, _classCallCheck3.default)(this, TrackPartHeader);
    return (0, _possibleConstructorReturn3.default)(this, (TrackPartHeader.__proto__ || (0, _getPrototypeOf2.default)(TrackPartHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrackPartHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          children = _props.children,
          part = _props.part;


      return _react2.default.createElement(
        'div',
        { className: styles.partHeaderContainer },
        _react2.default.createElement(
          'span',
          { className: styles.partHeader },
          t('Part'),
          ' ',
          part
        ),
        children
      );
    }
  }]);
  return TrackPartHeader;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
  part: _propTypes2.default.number,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  part: 0
}, _temp)) || _class);
exports.default = TrackPartHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TrackPartHeader/TrackPartHeader.js
// module id = 856
// module chunks = 1